import { useContext } from 'react';
import {
  ServiceLocationContext,
  type ServiceLocationContextValue,
} from './locationContextValue';

/**
 * Read the selected service location and its state - the single canonical
 * consumption path for the app-level location scope (DNKADM-0033 U2).
 *
 * Throws if used outside a `LocationProvider`.
 */
export function useServiceLocation(): ServiceLocationContextValue {
  const ctx = useContext(ServiceLocationContext);
  if (!ctx) throw new Error('useServiceLocation must be used within a LocationProvider');
  return ctx;
}
